import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'unh-testimonial-box',
  templateUrl: './testimonial-box.component.html',
  styleUrls: ['./testimonial-box.component.scss']
})
export class TestimonialBoxComponent implements OnInit {
  @Input() avatar: any;
  @Input() name: any;
  @Input() specialty: any;
  @Input() rating: any;
  @Input() content: any;

  constructor() { }

  ngOnInit(): void {
  }

}
